import axios from "axios";
import { apiURI, authErrorRedirect } from "../../common";

export async function handleAddNewERPItemCode(
  setErrors,
  setIsSubmitting,
  sampleDetails,
  setReloadData,
  history
) {
  setErrors({});
  // Start loading state
  setIsSubmitting(true);
  // Make POST request to API to edit item ERP code
  await axios
    .post(`${apiURI}/form/addNewItemERPCode`, sampleDetails)
    .then(() => {
      // Reset loading state
      setIsSubmitting(false);
      // Reload data after successful approval
      setReloadData(true);
    })
    .catch((response) => {
      console.log("error in axios form call react");
      // Clear errors
      setErrors({});
      // Set errors received from server response
      setErrors(response.response.data);
      // Redirect on authentication error
      authErrorRedirect(response.response.data, history);
    });

  // eslint-disable-next-line no-console
}
